import store from "../../../redux/store";
import {selectGameType, selectPlayers} from "../../../redux/reducers/sharedStateReducer/selectors";
import {GAME_TYPES} from "../../../constants/game";
import {NEUTRAL_PLAYER_ID} from "../../../constants/players";

export const checkIfCurrentUserOwner = (userId, ownerId) => {
  const state = store.getState();
  const gameType = selectGameType(state);

  if (ownerId === NEUTRAL_PLAYER_ID) {
    return false;
  }
  // Просмотр записи матча: ничей отряд не считается "моим", даже если
  // ownerId совпадает с userId зрителя (свой же матч)
  if (gameType === GAME_TYPES.REPLAY) {
    return false;
  }
  if (gameType === GAME_TYPES.LOCAL) {
    // Отряды ботов недоступны живым игрокам — как отряды противника в сетевой игре
    const owner = selectPlayers(state).find((player) => player.id === ownerId);
    return !(owner && owner.isBot);
  }

  // Админ, перехвативший управление ботом (см. getActingPlayer): отряды этого
  // бота — его отряды (переброс кубиков, приоритетная цель в ближнем бою)
  if (userId) {
    const owner = selectPlayers(state).find((player) => player.id === ownerId);
    if (owner && owner.isBot && owner.botControlledByUserId === userId) {
      return true;
    }
  }

  return userId === ownerId;
}
